"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditSheet = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const table_1 = require("client/components/material/table");
const floating_page_1 = require("client/components/page/floating-page");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/users/store");
const Table_1 = require("material-ui/Table");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
require("./audit-sheet.less");
const alert_1 = require("client/components/ui/alert");
const store_3 = require("client/modules/store");
const claim_1 = require("shared/claim");
const columns = [
    {
        center: false,
        id: "claimId",
        numeric: false,
        label: "Claim ID"
    },
    {
        center: false,
        id: "patient",
        numeric: false,
        label: "Patient"
    },
    {
        center: false,
        id: "date",
        numeric: false,
        label: "Date Processed",
        sortable: true
    },
    {
        center: false,
        id: "status",
        numeric: false,
        label: "Status",
        sortable: false
    },
    {
        center: false,
        id: "reason",
        numeric: false,
        label: "Cancel Reason",
        sortable: true
    }
    // {
    //   center: false,
    //   id: "req",
    //   numeric: false,
    //   label: "Request",
    //   sortable: false,
    // },
    // {
    //   center: false,
    //   id: "res",
    //   numeric: false,
    //   label: "Response",
    //   sortable: false,
    // },
];
const auditRows = [];
/**
 * @author MD
 * @classdesc Populates a med log with paid or dispensed claims.
 * Currently, this script is only populating PPMM's Beta sheet; this is
 * hardcoded in the google-server.tsx file. The audit is also not "updating"
 * existing data, but overwriting based on the title of field locations.
 * @todo Make audit export site based by selection.
 * @todo Don't overwrite existing data, but update and append instead.
 * @see google-server.tsx Related server file with hardcoded data.
 */
let AuditSheet = class AuditSheet extends React.Component {
    constructor() {
        super(...arguments);
        this.startDate = new Date();
        this.endDate = new Date();
        this.order = "DESC";
        this.orderBy = "date";
        this.claims = [];
        this.claimQuery = async (master) => {
            if (master) {
                this.startDate = new Date(2019, 0, 1);
                this.endDate = new Date(2019, 11, 31);
            }
            const result = await store_1.ordersStore.loadClaimsInterval({
                start: this.startDate,
                end: this.endDate
            });
            this.claims = mobx_1.toJS(result.orders);
            // const eRegex = /REVERSAL ACCEPTED/gi; // need to change
            this.claims = this.claims.filter((claim) => {
                // const liveReverse = claim.message.match(eRegex);
                const cError = claim.status === claim_1.ClaimStatus.Error;
                const cDispensed = claim.status === claim_1.ClaimStatus.Dispensed;
                const cPaid = claim.status === claim_1.ClaimStatus.Paid;
                const cReversed = claim.status === claim_1.ClaimStatus.Reversed;
                if (!cError && (cDispensed || cPaid || cReversed)) {
                    return true;
                }
                return false;
            });
        };
        this.renderTable = () => (React.createElement("div", { className: "audit__list" },
            React.createElement(table_1.MaterialTable, { columns: columns, 
                // onRequestSort={this.onRequestSort}
                order: this.order, orderBy: this.orderBy, rows: this.claims, renderRow: this.renderTableRow })));
        this.renderTableRow = (row, index) => {
            const req = (row.requests && JSON.parse(row.requests)) || null;
            const res = (row.responses && JSON.parse(row.responses)) || null;
            const cStatus = row.status === claim_1.ClaimStatus.Dispensed
                ? "Dispensed"
                : row.status === claim_1.ClaimStatus.Paid
                    ? "Paid Pending"
                    : "Reversed";
            const date = moment(row.date).format("MM/DD/YYYY - hh:mm a");
            const patient = req && req[0] && req[0].patient;
            const name = patient && `${patient.firstname} ${patient.lastname}`;
            const cancelReason = row.cancelReason || "";
            // console.log(req);
            if (req && cStatus) {
                return (React.createElement(table_1.MaterialTableRow, { key: index, to: `/claims/${row.orderId}` },
                    React.createElement(Table_1.TableCell, null, row.id),
                    React.createElement(Table_1.TableCell, null, name),
                    React.createElement(Table_1.TableCell, null, date),
                    React.createElement(Table_1.TableCell, null, cStatus),
                    React.createElement(Table_1.TableCell, null, cancelReason)));
            }
        };
        // if exportType = master then update all rows where Rx # doesn't already exist (NEXT UPDATE)
        // then wipe the table and update it with ALL CLAIMS FROM JANUARY TO DECEMBER
        // otherwise if export = sectional then wipe sectional and update with all claims from X to yY
        this.handleExport = async (master) => {
            if (master)
                await this.claimQuery(true);
            this.claims.forEach((claim) => {
                const req = (claim.requests && JSON.parse(claim.requests)[0]) || null;
                const res = (claim.responses && JSON.parse(claim.responses)[0]) || null;
                const cStatus = (claim && claim.status) || null;
                // console.log(req);
                /**
                 * req => The claim was live.
                 * claim.status !== ClaimStatus.Error => ERX didn't deny.
                 */
                if (req && cStatus !== claim_1.ClaimStatus.Error) {
                    // <-- Aliases -->
                    const groups = req.groups;
                    const header = req.header;
                    const insurance = req.insurance;
                    const patient = req.patient;
                    const pLast = patient.lastname.toUpperCase().trim();
                    const pFirst = patient.firstname.toUpperCase().trim();
                    const claimDate = header.serviceDate;
                    const reasonNotDispensed = claim.cancelReason;
                    const ndcRaw = groups[0].claim.serviceId.trim();
                    // const qtyRaw = groups[0].claim.quantityDispensed;
                    const qtyApproved = claim.quantity;
                    const rx = claim.id.toString();
                    const insuranceReimb = claim.totalAmount / 100;
                    const coPay = claim.copayAmount / 100;
                    // const quantityDispensed = claim.dispenseQuantity || '';
                    // Rebuild NDC from 12 digit package.
                    let ndc = ndcRaw.split("");
                    ndc.splice(9, 0, "-");
                    ndc.splice(5, 0, "-");
                    ndc = ndc.join("");
                    // <-- Log Sheet Data -->
                    const logRowObj = {
                        patientName: `${pLast}, ${pFirst}`,
                        clinicDateOfService: moment(req.date)
                            .format("MM-DD")
                            .toString(),
                        imbDateOfService: moment(claimDate) // ? Does this need to be dispense date?
                            .format("MM-DD")
                            .toString(),
                        ndc,
                        // medName: null, // Auto-generated in sheet.
                        quantityApproved: qtyApproved,
                        insuranceReimb,
                        coPay,
                        rx,
                        dispensed: cStatus === claim_1.ClaimStatus.Dispensed
                            ? "Y"
                            : cStatus === claim_1.ClaimStatus.Paid
                                ? "I"
                                : "N",
                        reasonNotDispensed
                        // quantityDispensed,
                        // dispensedAmnt
                    };
                    const logRowArr = [
                        logRowObj.patientName,
                        logRowObj.clinicDateOfService,
                        null,
                        logRowObj.imbDateOfService,
                        logRowObj.ndc,
                        // logRowObj.medName, // 4 F
                        null,
                        logRowObj.quantityApproved,
                        logRowObj.insuranceReimb,
                        null,
                        logRowObj.coPay,
                        logRowObj.rx,
                        null,
                        logRowObj.dispensed,
                        logRowObj.reasonNotDispensed // 10 N
                        // logRowObj.quantityDispensed, // 11 Managed by the Sheet
                        // logRowObj.dispensedAmnt, // 12 Managed by the Sheet
                    ];
                    // console.log(logRowArr);
                    auditRows.push(logRowArr);
                }
            });
            // console.log(auditRows);
            store_3.generalStore.exportAuditLogs(auditRows, master);
            alert("Logs exported to Google Sheets."); // Temp alert.
        };
        this.handleChangeDate = () => {
            this.claimQuery();
        };
    }
    render() {
        return (React.createElement("div", null, store_2.usersStore.permissions.ReadAudit ? (React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false },
                React.createElement(kpi_title_1.KpiTitle, { label: "Audit Exporter" })),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement(alert_1.UiAlert, { title: "Notice", type: "warning", message: `The audit exporting tool only displays claims that were processed by the ERX server.
                \rExports are currently mapped to the PPMA Beta sheet during the initial pre-alpha release.
                \nExporting a date-range will post data to 'Approvals Temporary', overwriting old data.
                \nExporting the accumulative year will post to 'Approvals 2019'.` }),
                React.createElement("div", { className: "audit-wrapper" },
                    React.createElement("div", { className: "date-wrapper" },
                        React.createElement(date_picker_1.MaterialDatePicker, { label: "Start Date", className: "date end-date", onChange: (e) => {
                                this.startDate = e;
                                this.handleChangeDate();
                            }, value: this.startDate }),
                        React.createElement(date_picker_1.MaterialDatePicker, { label: "End Date", className: "date start-date", onChange: (e) => {
                                this.endDate = e;
                                this.handleChangeDate();
                            }, value: this.endDate })),
                    React.createElement("div", { className: "date-wrapper date-wrapper__buttons" },
                        React.createElement("div", { className: "date-wrapper--spacer" },
                            React.createElement(ui_1.UiButton, { primary: true, onClick: () => this.handleExport(false) }, "Export Range")),
                        React.createElement(ui_1.UiButton, { secondary: true, onClick: () => this.handleExport(true) }, "Export 2019")),
                    React.createElement("div", { className: "audit__preview" }, this.renderTable()))))) : (store_2.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], AuditSheet.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], AuditSheet.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], AuditSheet.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], AuditSheet.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], AuditSheet.prototype, "claims", void 0);
AuditSheet = __decorate([
    mobx_react_1.observer
], AuditSheet);
exports.AuditSheet = AuditSheet;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/audit/modules/audit-sheet.tsx
// module id = 3267
// module chunks = 0